import React, {useEffect, useState} from 'react';
import {Box, CircularProgress, Paper, TextField, Typography,} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import RefreshIcon from '@material-ui/icons/Refresh';
import MaterialTable from 'material-table';
import useStyles from '../styles/styles';
import {useLazyQuery, useMutation, useQuery} from '@apollo/react-hooks';
import {gql} from 'apollo-boost';
import TableIcons from '../utils/TableIcons';
import getEnvironment from "../utils/getEnvironment";
import useCustomApolloClient from "../apollo/useCustomApolloClient";
import CopyButton from "../utils/CopyButton";

const Websites = () => {
    const classes = useStyles();
    const env = getEnvironment();
    const [manualLoad, setManualLoad] = useState(false);
    const client = useCustomApolloClient()
    const [websiteData, setWebsiteData] = useState({});
    const [getWebsites, {loading, error, data, refetch}] = useLazyQuery(gql`
        query AllWebsite {
            allWebsite {
                name
                baseUrl
                entityId
            }
        }
    `, {
        notifyOnNetworkStatusChange: true,
        client: client
    });

    const [updateWebsite, {
        loading: updateWebsiteLoading,
        error: updateWebsiteError,
        data: updateWebsiteData
    }] = useMutation(gql`
        mutation UpdateWebsite(
            $input: WebsiteInput!
        ) {
            updateWebsite(
                input: $input
            ) {
                name
                baseUrl
                entityId
            }
        }
    `, {client: client});

    const [createWebsite, {
        loading: createWebsiteLoading,
        error: createWebsiteError,
        data: createWebsiteData
    }] = useMutation(gql`
        mutation createWebsite(
            $input: WebsiteInput!
        ) {
            createWebsite(
                input: $input
            ) {
                name
                baseUrl
                entityId
            }
        }
    `, {client: client});

    useEffect(() => {
        if (createWebsiteData && Object.keys(createWebsiteData).length || updateWebsiteData && Object.keys(updateWebsiteData).length) {
            setManualLoad(true);
            setTimeout(() => {
                window.location.reload();
            }, 3000);
        }

    }, [createWebsiteData, updateWebsiteData]);

    useEffect(() => {
        if (!loading && manualLoad) {
            setManualLoad(false);
        }
    }, [loading]);

    useEffect(() => {
        getWebsites();
    }, []);

    useEffect(() => {
        setWebsiteData(data);
    }, [data]);

    const handleKey = (e) => {
        if (e.key === 'Enter') {
            e.stopPropagation()
        }
    }


    const WebsiteTable = () => (
            <MaterialTable
                title=""
                icons={TableIcons}
                columns={[
                    {
                        title: 'Website Id', field: "entityId", editable: "never", render: (data) => {
                            return (
                                <Box display='flex'>
                                    <strong>{data.id}</strong>
                                    <CopyButton data={data.id} copyText={'Copy Id'} disableText={true}></CopyButton>
                                </Box>
                            )
                        }
                    },
                    {
                        title: "Name", field: "name",
                        editComponent: props => (
                            <TextField
                                value={props.value}
                                type="text"
                                onChange={e => props.onChange(e.target.value)}
                                error={!props.value}
                                onKeyDown={e => handleKey(e)}
                                className={classes.textField}
                            />
                        )
                    },
                    {
                        title: "BaseUrl", field: "baseUrl",
                        editComponent: props => (
                            <TextField
                                value={props.value}
                                type="text"
                                onChange={e => props.onChange(e.target.value)}
                                error={!props.value}
                                onKeyDown={e => handleKey(e)}
                                className={classes.textField}
                            />
                        )
                    },
                ]}
                data={websiteData.allWebsite.map(website => ({
                    id: website.entityId,
                    name: website.name,
                    baseUrl: website.baseUrl
                }))}
                editable={{
                    onRowAdd: env === 'test' ? newData =>
                        new Promise((resolve, reject) => {
                            setTimeout(() => {
                                createWebsite({
                                    variables: {
                                        input: {...newData}
                                    }
                                });

                                setManualLoad(true);
                                if (!createWebsiteLoading) {
                                    refetch();
                                    resolve();
                                }

                            }, 1000);
                        }) : null,
                    onRowUpdate: env === 'test' ? (newData, oldData) =>
                        new Promise((resolve, reject) => {
                            setTimeout(() => {
                                updateWebsite({
                                    variables: {
                                        input: {...newData}
                                    }
                                });
                                setManualLoad(true);
                                if (!updateWebsiteLoading) {
                                    refetch();
                                    resolve();
                                }
                            }, 1000);
                        }) : undefined,
                }}
                actions={[
                    {
                        icon: () => <RefreshIcon/>,
                        tooltip: 'Refetch Data',
                        isFreeAction: true,
                        onClick: (event) => refetch()
                    },
                ]}
                options={{
                    addRowPosition: 'first',
                    pageSize: 100,
                    pageSizeOptions: [100, 200, 300],
                    headerStyle: {
                        minWidth: 'auto',
                    }
                }}
            />
    );

    return (
        <>
            <Typography variant="h2">
                Websites
            </Typography>
            {(!loading && error) || (!createWebsiteLoading && createWebsiteError) || (!updateWebsiteLoading && updateWebsiteError) ? (
                <Paper className={classes.paper}>
                    <Alert severity="error">There is an error!</Alert>
                    <pre>{JSON.stringify((error || createWebsiteError || updateWebsiteError), null, 2)}</pre>
                </Paper>
            ) : null}
            {loading || manualLoad ? (
                <Paper className={classes.paper}>
                    <div className={classes.loadingBar}>
                        <CircularProgress
                            size={50}
                            thickness={4}
                        />
                    </div>
                </Paper>
            ) : null}
            {!manualLoad && websiteData && websiteData.allWebsite ? (
                <WebsiteTable/>
            ) : null}
        </>
    );
};

export default Websites;
